module.exports = __webpack_public_path__ + "static/img/logo.e5a8c00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 26